import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Booking() {
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState('');
  const [currency, setCurrency] = useState('USD');
  const [formData, setFormData] = useState({
    customer_name: '',
    vehicle_reg: '',
    email: '',
    phone: '',
    booking_date: '',
    booking_time: ''
  });

  useEffect(() => {
    fetchPackages();
    fetchCurrency();
  }, []);

  const fetchCurrency = async () => {
    try {
      const response = await axios.get('/api/settings');
      setCurrency(response.data.currency || 'USD');
    } catch (error) {
      console.error('Error fetching currency:', error);
    }
  };

  const fetchPackages = async () => {
    try {
      const response = await axios.get('/api/packages');
      setPackages(response.data);
    } catch (error) {
      console.error('Error fetching packages:', error);
    }
  };

  const handleSelectPackage = (pkg) => {
    setSelectedPackage(pkg);
    setShowForm(true);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/api/bookings', {
        package_id: selectedPackage.id,
        package_name: selectedPackage.name,
        ...formData
      });
      setReferenceNumber(response.data.referenceNumber || '');
      setShowForm(false);
      setShowConfirmation(true);
      setFormData({
        customer_name: '',
        vehicle_reg: '',
        email: '',
        phone: '',
        booking_date: '',
        booking_time: ''
      });
    } catch (error) {
      console.error('Error creating booking:', error);
      alert('Failed to create booking. Please try again.');
    }
  };

  if (showConfirmation) {
    return (
      <div className="container">
        <div className="confirmation">
          <div className="icon">✓</div>
          <h2>Booking Confirmed!</h2>
          <p>Thank you for booking with us.</p>
          {referenceNumber && (
            <p>Your reference number is: <strong>{referenceNumber}</strong></p>
          )}
          <p>We'll contact you shortly at <strong>{formData.email}</strong> to confirm your appointment.</p>
          <button className="btn" onClick={() => {
            setShowConfirmation(false);
            setSelectedPackage(null);
            setReferenceNumber('');
          }}>
            Book Another Service
          </button>
        </div>
      </div>
    );
  }

  if (showForm && selectedPackage) {
    return (
      <div className="container">
        <h2 className="section-title">Complete Your Booking</h2>
        <div style={{ maxWidth: '600px', margin: '2rem auto' }}>
          <div className="card">
            <h3>Selected Package: {selectedPackage.name}</h3>
            <div className="price">{currency} {selectedPackage.price}</div>
          </div>
          
          <form onSubmit={handleSubmit} className="card">
            <div className="form-group">
              <label>Full Name *</label>
              <input
                type="text"
                name="customer_name"
                value={formData.customer_name}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Vehicle Registration *</label>
              <input
                type="text"
                name="vehicle_reg"
                value={formData.vehicle_reg}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Email Address *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Phone Number *</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="form-group">
                <label>Preferred Booking Date *</label>
                <input
                  type="date"
                  name="booking_date"
                  value={formData.booking_date}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Preferred Time *</label>
                <select
                  name="booking_time"
                  value={formData.booking_time}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select a time</option>
                  <option value="09:00">9:00 AM</option>
                  <option value="10:00">10:00 AM</option>
                  <option value="11:00">11:00 AM</option>
                  <option value="12:00">12:00 PM</option>
                  <option value="13:00">1:00 PM</option>
                  <option value="14:00">2:00 PM</option>
                  <option value="15:00">3:00 PM</option>
                  <option value="16:00">4:00 PM</option>
                  <option value="17:00">5:00 PM</option>
                </select>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '1rem' }}>
              <button type="submit" className="btn">Confirm Booking</button>
              <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>
                Back to Packages
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <section className="section">
        <h2>Our Packages</h2>
        <p>Choose the perfect detailing package for your vehicle</p>
      </section>

      <div className="packages-grid">
        {packages.map(pkg => (
          <div key={pkg.id} className="package-card">
            <h3>{pkg.name}</h3>
            <div className="price">{currency} {pkg.price}</div>
            <p className="description">{pkg.description}</p>
            <ul>
              {pkg.features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
            <button className="btn" onClick={() => handleSelectPackage(pkg)}>
              Book Now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Booking;
